

const TitleContainer = ({ icon, title }) => {
  return (
    <div className="flex items-center gap-2">
      <div className="bg-[#E7E9EC] p-[10px] rounded-lg">
        <img src={icon} alt="" width={16} height={16} />
      </div>
      <p className="flex-1 font-semibold text-[16px] "> {title}</p>
    </div>
  );
};

export default TitleContainer;
